import {  useState, useEffect, useContext } from "react";
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import SearchContext from 'src/context/SearchContext';
import OSDViewer from 'src/components/OSDViewer';
import PDFViewer from 'src/components/PDFViewer';
import IMGSViewer from 'src/components/IMGSViewer';
import 'src/css/Item.scss';

const MEDIA_URL = import.meta.env.VITE_MEDIA_URL || '';

const dummyImgs = ({original, thumbnail}) => {
    return [1,2,3].map(i => { return {
        original,
        thumbnail,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    };
    })
}

const Item = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const { item, loading, loadItem } = useContext(SearchContext);
    const [vista, setVista] = useState('');
    const [navg, setNavg] = useState(null);
    const [imgs, setImgs] = useState([]);

    const [ficha, setFicha] = useState(null);

    const [info, setInfo] = useState(true);

    useEffect(() => {
        if (!loading && id) loadItem(id)
    }, [id]);

    useEffect(()=>  {
        window.scrollTo(0, 0);
    },[]);

    useEffect(()=>  {
        if (item.id) {
            // console.log(item.caso);
            // setImgs(dummyImgs({
            //     original: item.iipbigthumb,
            //     thumbnail: item.iipthumb,
            // })
            // );
            setImgs(item.caso.imagenes_complementarias.map(i => {
                return {
                    original: MEDIA_URL + i.url,
                    description: i.descripcion,
                };
            }))

            setFicha(MEDIA_URL + item.caso.ficha)
        }
    }, [item]);

    useEffect(() => {
        if (!loading) setVista('vmicro')
    }, [loading]);

    const hClick = (ev) => {
        setVista(ev.target.value)
        if (ev.target.value === 'vmicro') {
            setInfo(true);
        }
    }


    return (
        <main className="item">
            <div className="nav">
                <Link onClick={() => navigate(-1)} className="liga-back ico-f1w lnk">
                    <i className="arrow left icon"></i>
                    <span>Regresar</span>
                </Link>
            </div>
            <div className="content">
                <div className="pane-menu">
                    <button
                        className={`pane-item ${vista === 'vmicro' ? 'active' : ''}`}
                        value="vmicro"
                        onClick={hClick}
                    >Microscopio</button>
                    <button
                        className={`pane-item ${vista === 'vficha' ? 'active' : ''}`}
                        value="vficha"
                        onClick={hClick}
                    >Ficha</button>
                    { imgs?.length > 0 &&
                        <button
                            className={`pane-item ${vista === 'vzonas' ? 'active' : ''}`}
                            value="vzonas"
                            onClick={hClick}
                        >Imágenes complementarias</button>
                    }
                </div>
                <div className="panes">
                    <div className={`pane info ${vista === 'vmicro' ? 'active' : ''} ${info ? 'open' : 'closed'}`}>
                        <i className={`btn-cls angle double icon ${info ? 'left' : 'right'}`}
                            title={`Ocultar`}
                            onClick={() => setInfo(ni => !ni)}
                        ></i>

                        <SimpleBar className="datos">
                            <div className="title">{item?.caso?.titulo}</div>
                            <div className="title">Diagnóstico morfológico:</div>
                            <div className="value">{item?.caso?.diagnostico_morfologico}</div>
                            <div className="title">Descripción microscópica:</div>
                            <div className="value">{item?.caso?.descripcion_microscopica}</div>
                            <div className="title">Datos del animal:</div>
                            <div className="value">{item?.caso?.datos_animal}</div>
                            {item?.caso?.etiologia &&
                            <>
                                <div className="title">Etiología:</div>
                                <div className="value">{item.caso.etiologia}</div>
                            </>
                            }
                            {item?.caso?.informacion_adicional &&
                            <>
                                <div className="title">Información adicional:</div>
                                <div className="value">{item.caso.informacion_adicional}</div>
                            </>
                            }
                        </SimpleBar>
                    </div>

                    { item.iipimg && item.iipimg !== '' &&
                        <OSDViewer source={item.iipimg} vista={vista} navg={navg} active={vista === 'vmicro'}/>
                    }
                    { ficha &&
                        <PDFViewer source={ficha} vista={vista} active={vista === 'vficha'}/>
                    }
                    <IMGSViewer imgs={imgs} vista={vista} active={vista === 'vzonas'}/>
                    {loading && <div className="loading"> <Loader active inline='centered'/> </div>}
                </div>
            </div>

        </main>
    );

};

export default Item;
